import { Component, inject } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';

export interface SnackBarMessagePart {
  text: string;
  bold?: boolean;
}

@Component({
  selector: 'app-html-snack-bar',
  templateUrl: './html-snack-bar.component.html',
  styleUrls: ['./html-snack-bar.component.scss'],
  standalone: false,
})
export class HtmlSnackBarComponent {
  data = inject<{
    messageParts: SnackBarMessagePart[];
    action?: string;
  }>(MAT_SNACK_BAR_DATA);
  snackBarRef = inject<MatSnackBarRef<HtmlSnackBarComponent>>(MatSnackBarRef);
}
